var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutTime({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0379 20.8711H8.90771V27.2554H13.0379V20.8711Z",
    fill: "#FF4949"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90771 0V11.4645H13.0379V4.1317H26.2597V27.257H30.39V0H8.90771Z",
    fill: "#FF4949"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6642 18.1194L13.2412 18.1194L13.2412 14.2185L6.6642 14.2185L6.6642 11.6561L0.389677 16.1688L6.6642 20.6816L6.6642 18.1194Z",
    fill: "#FF4949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutTime);
export default __webpack_public_path__ + "static/media/out_time.0a79cb506a5f60b7c7cbbaf6a77d9373.svg";
export { ForwardRef as ReactComponent };